// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const addMutation = graphql`
	mutation vocabularyAddMutation($input: VocabularyAddInput!) {
		VocabularyAdd(input: $input) {
			error
			vocabularyEdge {
				node {
					id
				}
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: addMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			if (response.VocabularyAdd === undefined) {
				callback('Ошибка во время сохранения');
				return;
			}
			const { error, vocabularyEdge } = response.VocabularyAdd;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, vocabularyEdge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/components/vocabulary/mutations/vocabulary-add.js